import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/react-wrap-balancer/dist/index.mjs");
